import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invoices-list',
  templateUrl: './invoices-list.component.html',
  styleUrls: ['./invoices-list.component.css'],
})
export class InvoicesListComponent {
  url: string = 'invoice';
  url_two: string = 'quickbooks';

  data: Array<any> = [];
  isLoading: boolean = false;
  apiUrl = environment.apiUrl;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Qu',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    }, */
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  auth(): void {
    this.dataService.getData(`${this.url}/zoho/auth`).subscribe((response) => {
      console.log('response auth', response);

      if (response) {
        window.open(response.url, '_self');
      }
    });
  }

  getData(): void {
    //this.isLoading = true;
    this.dataService.getData(this.url).subscribe((response) => {
      this.data = response.data;
      console.log('invoices data', response);
      this.isLoading = false;
    });
  }

  deleteData(id: string): void {
    if (!confirm('You want to delete the record?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  getInvoice(invoiceId: string) {
    const pdfUrl = `${this.apiUrl}/${this.url}/downloadInvoice/${invoiceId}`;
    window.open(pdfUrl, '_blank');
  }
}
